import { Injectable } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class GenerateAnalysisFormgroupService {
  getGenerateAnalysisFormgroup(): FormGroup {
    let analysisFormgroup: FormGroup;

    analysisFormgroup = new FormGroup({
      operationNumber: new FormControl('', [Validators.required]),
      language: new FormControl('', Validators.required),
      auditDate: new FormControl('', Validators.required),
      controlReport: new FormControl('', Validators.required),
      reviewDocument: new FormControl(''),
      ICRDocument: new FormControl(''),
      minPage: new FormControl(undefined),
      maxPage: new FormControl(undefined),
    });

    return analysisFormgroup;
  }
}
